module.exports = __webpack_public_path__ + "static/dev-mobile-565999473657881c21dae25537a7cf47.jpg";